import { ReactNode } from "react";
import { InitialValues } from "./initial-values-types";
import { InitialValuesContext } from "./initial-values-context";

export function InnerInitialValuesProvider({
  children,
  initialValues,
}: {
  children: ReactNode;
  initialValues: InitialValues;
}) {
  return (
    <InitialValuesContext.Provider value={initialValues}>
      {children}
    </InitialValuesContext.Provider>
  );
}
